
export function UserInputAnswerViewConstructor(services, callbacks, context) {

  let joint = services.joint;
  return joint.shapes.html.AbstractElementView.extend({

    template: `
      <div class="html-element answer">
      <div class="anwser-image-and-text-container">
        <div class="anwser-text-container">
          <div class="answer-label"></div>
        </div>
      </div>
      <div class="answer-handover-text">${services.$translate.instant('parameters/quick_replies/details/handover')}</div>
      <div class="answer-edit-container"><span class="glyphicon glyphicon-pencil answer-edit"></span></div>
    </div>`,

    initialize: function () {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);
      const editSection = this.$box.find('.answer-edit');
      editSection.on('click', this.editAnswer.bind(this));
      this.model.attr({ rect: { 'pointer-events': 'none' } });
    },


    editAnswer: function () {
      let parent = this.model.getAncestors()[0];
      let parentView = this.paper.findViewByModel(parent);

      function resultAction(result) {
        if (result) {
          this.model.set('answerType', 'user-input');
          this.model.set('hasHandover', result.hasHandover);
          parentView.saveSpecialInputId('user-input', 'user_input_answer_id');
          callbacks.updateSerializedGraph(this.model.graph);
        }
        //Reorder and resize needed for both editing and deleting
        parentView.reorderChildren();
        parentView.resizeQuestionBox();
      }

      let modalInstance = services.$uibModal.open({
        animation: true,
        template: require('./editUserInputAnswer.modal.html'),
        controller: 'editUserInputAnswerController',
        resolve: {
          companyId: () => context.companyId,
          siteId: () => context.site.id,
          siteTypeName: () => context.site.type_name,
          answer: function () {
            return {
              hasHandover: this.model.get('hasHandover'),
            };
          }.bind(this),
        }
      });
      modalInstance.result.then(resultAction.bind(this));
    },

    updateBox: function () {
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
      if (this.paper) {
        let answer_css = {};
        answer_css['font-style'] = 'italic';
        answer_css.color = '#F26101';
        if (!this.model.hasPort('out')) {
          this.model.addOutPort('out');
        }

        this.$box.find('.answer-label').text(services.$translate.instant('parameters/quick_replies/details/user_input'));
        this.$box.css(answer_css);

        // Display or not Handover text
        const $handoverTextEl = this.$box.find('.answer-handover-text');
        if (this.model.get('hasHandover')) {
          $handoverTextEl.css('display', 'block');
        } else {
          $handoverTextEl.css('display', 'none');
        }
      }
    },

  });
}
